// Poslední zvolená kategorie/region na stránce Předpovědi — localStorage.
// Na rozdíl od useLastMeteogramPoints.js nejde o seznam posledních položek, ale o jedinou
// aktuální volbu — pro Kraje a Hory se navíc pamatuje POSLEDNÍ REGION ZVLÁŠŤ pro každou
// kategorii (přepnutí na Hory nesmí zapomenout, jaký kraj byl vybraný předtím, a naopak),
// spolu s jeho čitelným názvem (region je jen kód RPxx, název se ukládá zvlášť, aby ho
// hlavní menu — LayoutMain, 3 odkazy pod ikonou Předpovědi — mohlo zobrazit bez dotazu na API).
const KEY = 'cw_last_forecast_selection'

const DEFAULT = { category: 'CR', regionByCategory: { Kraje: null, Hory: null } }

export function getLastForecastSelection() {
  try {
    const parsed = JSON.parse(localStorage.getItem(KEY) || 'null')
    if (!parsed) return DEFAULT
    return { ...DEFAULT, ...parsed, regionByCategory: { ...DEFAULT.regionByCategory, ...parsed.regionByCategory } }
  } catch {
    return DEFAULT
  }
}

// region/regionName: null pro kategorii ČR (nemá region dimenzi).
export function setLastForecastSelection({ category, region, regionName }) {
  const current = getLastForecastSelection()
  const regionByCategory = { ...current.regionByCategory }
  if (category === 'Kraje' || category === 'Hory') {
    regionByCategory[category] = region ? { region, name: regionName || null } : null
  }
  localStorage.setItem(KEY, JSON.stringify({ category, regionByCategory }))
}
